import { motion } from "framer-motion";

import { fadeInUp } from "../lib/animations";

export function TrendingPage() {
	return (
		<motion.div
			variants={fadeInUp}
			initial="hidden"
			animate="visible"
			className="mx-auto max-w-7xl px-4 py-16 text-center sm:px-6 lg:px-8"
		>
			<h1 className="text-3xl font-bold text-pastel-black">Trending Tokens</h1>
			<p className="mt-4 text-pastel-gray">Coming soon...</p>
		</motion.div>
	);
}
